/* eslint-disable react/prop-types */
import React from 'react'
import * as Yup from 'yup'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Styled Elements
import { FormInputGroupItem, FormGroupWrapper, TablePanelWrapper } from './AiDocumentUploadForm.elements'

// Views
import { Form, FormTextField } from 'views/components'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions

function AiDocumentUploadForm(props) {
  // Destructure
  const { values, viewMode, formRef, onSubmit } = props

  // Variables
  const validationSchema = Yup.object().shape({
    title: Yup.string().required(),
    summary: Yup.string().required(),
    web_url: Yup.string().nullable(),
    file: Yup.mixed().nullable(),
  })

  return (
    <Form formRef={formRef} initialValues={values} validationSchema={validationSchema} onSubmit={onSubmit}>
      <TablePanelWrapper>
        <FormGroupWrapper>
          <FormInputGroupItem>
            <FormTextField disabled={viewMode} label="Title" name="title" />
          </FormInputGroupItem>
          <FormInputGroupItem>
            <FormTextField disabled={viewMode} label="Summary" name="summary" />
          </FormInputGroupItem>
          <FormInputGroupItem>
            <FormTextField disabled={viewMode} label="Web URL (optional)" name="web_url" />
          </FormInputGroupItem>
        </FormGroupWrapper>
      </TablePanelWrapper>
    </Form>
  )
}

// Default Props
AiDocumentUploadForm.defaultProps = {
  formRef: {},
  values: {},
  viewMode: true,
}

// Proptypes Validation
AiDocumentUploadForm.propTypes = {
  formRef: PropTypes.shape({ root: PropTypes.string }),
  values: PropTypes.shape({
    title: PropTypes.string,
    summary: PropTypes.string,
    web_url: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    file: PropTypes.any,
  }),
  viewMode: PropTypes.bool,
  onSubmit: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(AiDocumentUploadForm)
